function sortOpenerFunc(){
  const sortOpener = document.querySelector("[sort-opener]");
  const sortBody = document.querySelector("[sort-body]");
  // const sortClose = document.querySelector("[sort-close]");
  if(!sortOpener || !sortBody){
    return;
  }
  function openSortBody() {
    sortBody.classList.add("open");
    sortOpener.classList.add("active"); // Add active class when opening
  }

  function closeSortBody() {
    sortBody.classList.remove("open");
    sortOpener.classList.remove("active"); // Remove active class when closing
  }

  sortOpener.addEventListener("click", function (event) {
    event.stopPropagation();
    if (sortBody.classList.contains("open")) {
      closeSortBody();
    } else {
      openSortBody();
    }
  });

  // sortClose.addEventListener("click", function (event) {
  //   event.stopPropagation();
  //   closeSortBody();
  // });

  document.addEventListener("click", function (event) {
    if (
      !sortBody.contains(event.target) &&
      sortBody.classList.contains("open")
    ) {
      closeSortBody();
    }
  });
 const custom__sort_wrapper = document.querySelector(".custom__sort");
  if (custom__sort_wrapper) {
    custom__sort_wrapper.addEventListener("click", function (event) {
      // let custom__sort_wrapper = event.target.closest('.custom__sort');

      let sortOpener_new = custom__sort_wrapper.querySelector("[sort-opener]");
      let sortBody_new = custom__sort_wrapper.querySelector("[sort-body]");

      sortOpener_new.classList.remove("active");
      sortBody_new.classList.remove("open");

      console.log("clicked", event.target);
      console.log("custom__sort_wrapper", custom__sort_wrapper);
    });
  }
}


function filterOpenFunc(){
  const filterOpener = document.querySelector('[filter-opener]');
  const filters = document.querySelector('#main-collection-filters, #main-search-filters');
  const hideFilters = document.querySelectorAll('[hide-filter]');

  const toggleBodyScroll = () => {
    if (window.innerWidth < 750) {
      if (filters.classList.contains('open')) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    } else {
      document.body.style.overflow = '';
    }
  };

  if (filterOpener) {
    filterOpener.addEventListener('click', function() {
      if (filters) {
        filters.classList.toggle('open');
        filterOpener.classList.toggle('active', filters.classList.contains('open'));
        toggleBodyScroll();
      }
    });
  }

  hideFilters.forEach(hideBtn => {
    hideBtn.addEventListener('click', function() {
      if (filters && filters.classList.contains('open')) {
        filters.classList.remove('open');
        filterOpener.classList.remove('active');
        toggleBodyScroll();
      }
    });
  });

  window.addEventListener('resize', toggleBodyScroll);
}




window.layoutSwitcherFunc = function() {
  const productGrid = document.querySelector(".product-grid");
  const layoutButtons = document.querySelectorAll(".column__switch-lg-wrapper button");

  if (!productGrid || !layoutButtons.length) return;

  // Constants
  const DESKTOP_CLASSES = ["grid--3-col-desktop", "grid--4-col-desktop"];
  const MOBILE_CLASSES = ["grid--1-col-tablet-down", "grid--2-col-tablet-down"];
  const ALL_CLASSES = [...DESKTOP_CLASSES, ...MOBILE_CLASSES];
  const STORAGE_KEY = "columnLayoutPreference";
  const EXPIRY_DAYS = 3;

  // Clear all layout classes
  function cleanUpGridClasses() {
    productGrid.classList.remove(...ALL_CLASSES);
  }

  // Set grid class and update button state
  function setGridClass(columnCount) {
    cleanUpGridClasses();
    
    const isDesktop = window.innerWidth >= 990;
    const classToAdd = isDesktop 
      ? `grid--${columnCount}-col-desktop`
      : `grid--${columnCount}-col-tablet-down`;
    
    productGrid.classList.add(classToAdd);
    updateActiveButton(columnCount);
  }

  // Update active button based on column count
  function updateActiveButton(columnCount) {
    layoutButtons.forEach(button => {
      const buttonColumn = parseInt(button.getAttribute("data-column"), 10);
      button.classList.toggle("active__column", buttonColumn === columnCount);
    });
  }

  // Save preference to localStorage
  function saveColumnPreference(columnCount) {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + EXPIRY_DAYS);

    const preference = {
      columnCount: columnCount,
      expiry: expiryDate.getTime()
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(preference));
  }

  // Get current active column count based on screen size
  function getCurrentColumnCount() {
    const isDesktop = window.innerWidth >= 990;
    const activeClasses = isDesktop ? DESKTOP_CLASSES : MOBILE_CLASSES;
    
    // Find which class is currently active
    const activeClass = activeClasses.find(cls => 
      productGrid.classList.contains(cls)
    );
    
    if (activeClass) {
      return parseInt(activeClass.match(/\d+/)[0], 10);
    }
    return null;
  }

  // Load preference or sync with current classes
  function loadColumnPreference() {
    const savedPreference = localStorage.getItem(STORAGE_KEY);
    
    if (savedPreference) {
      const preference = JSON.parse(savedPreference);
      
      // Check if preference is expired
      if (new Date().getTime() > preference.expiry) {
        localStorage.removeItem(STORAGE_KEY);
      } else {
        // Apply saved preference
        setGridClass(preference.columnCount);
        return;
      }
    }
    
    // No valid preference - use current classes
    const currentColumnCount = getCurrentColumnCount();
    if (currentColumnCount !== null) {
      updateActiveButton(currentColumnCount);
    }
  }

  // Handle button click
  function handleButtonClick(button, columnCount) {
    setGridClass(columnCount);
    saveColumnPreference(columnCount);
  }

  // Initialize
  function init() {
    // Set up button click handlers
    layoutButtons.forEach(button => {
      button.addEventListener("click", () => {
        const columnCount = parseInt(button.getAttribute("data-column"), 10);
        handleButtonClick(button, columnCount);
      });
    });

    // Handle resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        loadColumnPreference();
      }, 100);
    });

    // Initial load
    loadColumnPreference();
  }

  init();
}




window.hideActiveFilter = function() {
  const removeAll = document.querySelector('.active-facets facet-remove:only-child');
  const activeFilters = document.querySelectorAll('.active__filter');
  const mainFilters = document.querySelector('#main-collection-filters, #main-search-filters');
  
  if (removeAll) {
    const activeFilter = removeAll.closest('.active__filter');
    if (activeFilter) activeFilter.style.display = 'none';
    if (mainFilters) mainFilters.classList.remove('manipulate');
  } else {
    activeFilters.forEach(filter => filter.style.display = 'block');
    if (mainFilters) mainFilters.classList.add('manipulate');
  }
};




/*
window.filterAccordion = function(){
  const faqAccordions = document.querySelectorAll('.accordion-item');
  
  const openFaqAccordion = (accordion) => {
    const content = accordion.querySelector('.accordion-body');
    accordion.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
  };
  
  const closeFaqAccordion = (accordion) => {
    const content = accordion.querySelector('.accordion-body');
    accordion.classList.remove('active');
    content.style.maxHeight = null;
  };
  
  if (faqAccordions.length > 0) {
    faqAccordions.forEach((accordion) => {
      const header = accordion.querySelector('.accordion-header');
      const content = accordion.querySelector('.accordion-body');

      openFaqAccordion(accordion);

      header.addEventListener('click', (e) => {
        e.stopPropagation();
        if (content.style.maxHeight) {
          closeFaqAccordion(accordion);
        } else {
          openFaqAccordion(accordion);
        }
      });
    });
  }
}
*/


window.filterAccordion = function () {
  const faqAccordions = document.querySelectorAll(".accordion-item");

  const openFaqAccordion = (accordion) => {
    const content = accordion.querySelector(".accordion-body");
    accordion.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
  };

  const closeFaqAccordion = (accordion) => {
    const content = accordion.querySelector(".accordion-body");
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };

  // Check if URL contains "filter" or "sort"
  const url = window.location.href.toLowerCase();
  const shouldOpenAccordion = !url.includes("filter") && !url.includes("sort");

  if (faqAccordions.length > 0) {
    faqAccordions.forEach((accordion) => {
      const header = accordion.querySelector(".accordion-header");
      const content = accordion.querySelector(".accordion-body");

      // Only open accordion if URL doesn't contain "filter" or "sort"
      if (shouldOpenAccordion) {
        openFaqAccordion(accordion);
      }

      header.addEventListener("click", (e) => {
        e.stopPropagation();
        if (content.style.maxHeight) {
          closeFaqAccordion(accordion);
        } else {
          openFaqAccordion(accordion);
        }
      });
    });
  }
};


window.clearFilter = function() {
  const clearAllBtn = document.querySelector('[clear-all-filter]');
  const removeAllEl = document.querySelector('.remove__all-filter');
  const filtersPanel = document.querySelector('#main-collection-filters, #main-search-filters');

  if (clearAllBtn && removeAllEl && filtersPanel) {
    clearAllBtn.addEventListener('click', function() {
      // Trigger the remove all click
      removeAllEl.click();

      // Check and remove overflow: hidden from body if present
      if (document.body.style.overflow === 'hidden') {
        document.body.style.overflow = '';
      }

      // Close filters panel if open
      if (filtersPanel.classList.contains('open')) {
        setTimeout(() => {
          filtersPanel.classList.remove('open');
        }, 0);
      }
    });
  }
};


function scrollCollectionListsFunc() {
  const collectionsLists = document.querySelectorAll(".collections__list");

  if (collectionsLists.length > 0) {
    collectionsLists.forEach((container) => {
      const activeLink = container.querySelector("a.active");

      if (activeLink) {
        const scrollPosition =
          activeLink.offsetLeft -
          container.offsetWidth / 2 +
          activeLink.offsetWidth / 2;

        container.scrollTo({ left: scrollPosition, behavior: "smooth" });
      }
    });
  }
}


window.initWrapperHeightSync = function () {
  const image = document.querySelector('.card__media img');
  const wrappers = document.querySelectorAll('.--collection-promotion-card-wrapper');
  const switchButtons = document.querySelectorAll('.column__switch-lg-wrapper button');

  if (!image) return;

  window.setAllWrapperHeights = function () {
    const imgHeight = image.offsetHeight;
    wrappers.forEach(wrapper => {
      wrapper.style.height = `${imgHeight}px`;
    });
  };

  if (image.complete) {
    window.setAllWrapperHeights();
  } else {
    image.addEventListener('load', window.setAllWrapperHeights);
  }

  window.addEventListener('resize', window.setAllWrapperHeights);

  switchButtons.forEach(button => {
    button.addEventListener('click', window.setAllWrapperHeights);
  });
};


window.loadMore = () =>{
  const loadMoreButton = document.getElementById('load-more-button');
  const productGrid = document.getElementById('product-grid');
  const showingCount = document.getElementById('showing-count');

  if (!loadMoreButton || !productGrid) return;

  let isLoading = false;
  let currentPage = parseInt(loadMoreButton.dataset.currentPage);
  const totalPages = parseInt(loadMoreButton.dataset.totalPages);
  const totalItems = parseInt(loadMoreButton.dataset.totalItems);
  const itemsPerPage = parseInt(loadMoreButton.dataset.itemsPerPage);
  const collectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0] || '';

  loadMoreButton.addEventListener('click', function() {
    if (isLoading || currentPage >= totalPages) return;
    
    isLoading = true;
    loadMoreButton.textContent = 'Loading...';
    
    currentPage++;
    const url = buildUrl();
    
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const parser = new DOMParser();
        const html = parser.parseFromString(text, 'text/html');
        const newItems = html.getElementById('product-grid')?.innerHTML || '';
        
        if (newItems) {
          productGrid.insertAdjacentHTML('beforeend', newItems);
          
          const newShowingCount = Math.min(currentPage * itemsPerPage, totalItems);
          showingCount.textContent = newShowingCount;
          
          if (currentPage >= totalPages) {
            loadMoreButton.style.display = 'none';
          } else {
            loadMoreButton.textContent = 'Load More';
          }
        }
      })
      .catch(error => {
        console.error('Error loading more products:', error);
        loadMoreButton.textContent = 'Error - Try Again';
      })
      .finally(() => {
        isLoading = false;
        window.initWrapperHeightSync();
        window.cardProductFunc();
      });
  });

  function buildUrl() {
    const baseUrl = `/collections/${collectionHandle}`;
    const params = new URLSearchParams(window.location.search);
    params.set('page', currentPage);
    params.set('view', 'ajax');
    return `${baseUrl}?${params.toString()}`;
  }
}


window.searchLoadMore = () => {
  const loadMoreButton = document.getElementById('load-more-button');
  const productGrid = document.getElementById('product-grid');
  const showingCount = document.getElementById('showing-count');

  if (!loadMoreButton || !productGrid) return;

  let isLoading = false;
  let currentPage = parseInt(loadMoreButton.dataset.currentPage);
  const totalPages = parseInt(loadMoreButton.dataset.totalPages);
  const totalItems = parseInt(loadMoreButton.dataset.totalItems);
  const itemsPerPage = parseInt(loadMoreButton.dataset.itemsPerPage);
  const searchQuery = loadMoreButton.dataset.searchQuery;

  loadMoreButton.addEventListener('click', function() {
    if (isLoading || currentPage >= totalPages) return;
    
    isLoading = true;
    loadMoreButton.textContent = 'Loading...';
    
    currentPage++;
    const url = buildUrl();
    
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const parser = new DOMParser();
        const html = parser.parseFromString(text, 'text/html');
        const newItems = html.getElementById('product-grid')?.innerHTML || '';
        
        if (newItems) {
          productGrid.insertAdjacentHTML('beforeend', newItems);
          
          const newShowingCount = Math.min(currentPage * itemsPerPage, totalItems);
          showingCount.textContent = newShowingCount;
          
          if (currentPage >= totalPages) {
            loadMoreButton.style.display = 'none';
          } else {
            loadMoreButton.textContent = 'Load More';
          }
        }
      })
      .catch(error => {
        console.error('Error loading more results:', error);
        loadMoreButton.textContent = 'Error - Try Again';
      })
      .finally(() => {
        isLoading = false;
        if (window.initWrapperHeightSync) window.initWrapperHeightSync();
        if (window.cardProductFunc) window.cardProductFunc();
      });
  });

  function buildUrl() {
    const baseUrl = '/search';
    const params = new URLSearchParams(window.location.search);
    params.set('page', currentPage);
    params.set('view', 'ajax');
    
    // Ensure search query is included
    if (!params.has('q') && searchQuery) {
      params.set('q', searchQuery);
    }
    
    return `${baseUrl}?${params.toString()}`;
  }
}


/*
function makeUtilitiesFixed() {
  const collectionsList = document.querySelector(".toolbar__sort-filter");
  const headerSection = document.querySelector(".header-section");

  if (!collectionsList || !headerSection) return;

  const headerHeight = headerSection.offsetHeight;
  const initialOffset = collectionsList.offsetTop - headerHeight;
  let isSticky = false;
  let lastScroll = window.scrollY;

  // Pre-calculate the spacer element
  const spacer = document.createElement('div');
  spacer.style.height = `${collectionsList.offsetHeight }px`;
  spacer.style.display = 'none';
  collectionsList.parentNode.insertBefore(spacer, collectionsList);

  window.addEventListener('scroll', function() {
    const currentScroll = window.scrollY;
    const scrollDirection = currentScroll > lastScroll ? 'down' : 'up';
    lastScroll = currentScroll;

    // When scrolling down and reaching trigger point
    if (scrollDirection === 'down' && currentScroll >= initialOffset && !isSticky) {
      spacer.style.display = 'block'; // Prevent layout jump
      collectionsList.classList.add('sticky__nav');
      document.querySelector('#main-collection-filters').classList.add('sticky__nav_activated');
      
      collectionsList.style.top = `${headerHeight + 5}px`;
      isSticky = true;
    }
    // When scrolling up and passing original position
    else if (scrollDirection === 'up' && currentScroll <= initialOffset && isSticky) {
      collectionsList.classList.remove('sticky__nav');
       document.querySelector('#main-collection-filters').classList.remove('sticky__nav_activated');
      collectionsList.style.top = '';
      spacer.style.display = 'none';
      isSticky = false;
    }
  });
}
*/

/*
function makeUtilitiesFixed() {
  const utilitiesWrapper = document.querySelector(".toolbar__sort-filter");
  if (!utilitiesWrapper) return;

  const shopifySection = utilitiesWrapper.closest(".shopify-section");
  if (!shopifySection) return;

  const headerSection = document.querySelector(".header-section");
  if (!headerSection) return;

  const previousSiblings = [];
  let sibling = shopifySection.previousElementSibling;
  const hasNonZeroHeight = (el) => el && (el.offsetHeight > 0 || el.getBoundingClientRect().height > 0);

  while (sibling) {
    if (hasNonZeroHeight(sibling)) previousSiblings.push(sibling);
    sibling = sibling.previousElementSibling;
  }

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  if (!previousSiblings.length) {
    let isSticky = false;
    let initialOffset = null;

    const handleScroll = debounce(() => {
      if (initialOffset === null) initialOffset = shopifySection.offsetTop;
      const scrollY = window.scrollY || window.pageYOffset;
      const headerHeight = headerSection.getBoundingClientRect().height;
      const triggerPoint = initialOffset + 200 - headerHeight;

      if (scrollY >= triggerPoint && !isSticky) {
        utilitiesWrapper.classList.add("sticky__nav");
        utilitiesWrapper.style.top = `${headerHeight}px`;
        isSticky = true;
      } else if (scrollY < triggerPoint && isSticky) {
        utilitiesWrapper.classList.remove("sticky__nav");
        utilitiesWrapper.style.top = "";
        isSticky = false;
      }
    }, 100);

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return;
  }

  let isSticky = false;

  const handleIntersection = debounce((entries) => {
    const isAnySiblingVisible = entries.some((entry) => entry.isIntersecting);
    if (!isAnySiblingVisible && !isSticky) {
      const headerHeight = headerSection.getBoundingClientRect().height;
      utilitiesWrapper.classList.add("sticky__nav");
      utilitiesWrapper.style.top = `${headerHeight}px`;
      isSticky = true;
    } else if (isAnySiblingVisible && isSticky) {
      utilitiesWrapper.classList.remove("sticky__nav");
      utilitiesWrapper.style.top = "";
      isSticky = false;
    }
  }, 100);

  const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    threshold: 0,
    rootMargin: "-10px",
  });

  previousSiblings.forEach((el) => observer.observe(el));
}
*/


/*
function makeUtilitiesFixed() {
  const utilitiesWrapper = document.querySelector(".toolbar__sort-filter");
  if (!utilitiesWrapper) return;

  const shopifySection = utilitiesWrapper.closest(".shopify-section");
  if (!shopifySection) return;

  const headerSection = document.querySelector(".header-section");
  if (!headerSection) return;

  const previousSiblings = [];
  let sibling = shopifySection.previousElementSibling;
  const hasNonZeroHeight = (el) => el && (el.offsetHeight > 0 || el.getBoundingClientRect().height > 0);

  while (sibling) {
    if (hasNonZeroHeight(sibling)) previousSiblings.push(sibling);
    sibling = sibling.previousElementSibling;
  }

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  function calculateTotalTopHeight() {
    let headerHeight = headerSection.getBoundingClientRect().height;

    
    const countdownBar = document.querySelector(".new-countdown-bar");
    if (countdownBar) {
      headerHeight += countdownBar.getBoundingClientRect().height;
    }
    
    const announcementBar = document.querySelector(".announcement-bar-section");
    if (announcementBar) {
      headerHeight += announcementBar.getBoundingClientRect().height;
    }
    
    return headerHeight;
  }

  if (!previousSiblings.length) {
    let isSticky = false;
    let initialOffset = null;

    const handleScroll = debounce(() => {
      if (initialOffset === null) initialOffset = shopifySection.offsetTop;
      const scrollY = window.scrollY || window.pageYOffset;
      const totalTopHeight = calculateTotalTopHeight();
      const triggerPoint = initialOffset + 200 - totalTopHeight;

      if (scrollY >= triggerPoint && !isSticky) {
        utilitiesWrapper.classList.add("sticky__nav");
        utilitiesWrapper.style.top = `${totalTopHeight}px`;
        isSticky = true;
      } else if (scrollY < triggerPoint && isSticky) {
        utilitiesWrapper.classList.remove("sticky__nav");
        utilitiesWrapper.style.top = "";
        isSticky = false;
      }
    }, 100);

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return;
  }

  let isSticky = false;
  let stickyTimeout;

  const handleIntersection = debounce((entries) => {
    const isAnySiblingVisible = entries.some((entry) => entry.isIntersecting);

    if (!isAnySiblingVisible && !isSticky) {
      const totalHeight = previousSiblings.reduce(
        (sum, el) => sum + el.getBoundingClientRect().height,
        0
      );

      clearTimeout(stickyTimeout);

      const totalTopHeight = calculateTotalTopHeight();

      if (totalHeight < 150) {
        stickyTimeout = setTimeout(() => {
          utilitiesWrapper.classList.add("sticky__nav");
          utilitiesWrapper.style.top = `${totalTopHeight}px`;
          isSticky = true;
        }, 700);
      } else {
        utilitiesWrapper.classList.add("sticky__nav");
        utilitiesWrapper.style.top = `${totalTopHeight}px`;
        isSticky = true;
      }
    } else if (isAnySiblingVisible && isSticky) {
      clearTimeout(stickyTimeout);
      utilitiesWrapper.classList.remove("sticky__nav");
      utilitiesWrapper.style.top = "";
      isSticky = false;
    }
  }, 100);

  const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    threshold: 0,
    rootMargin: "-10px",
  });

  previousSiblings.forEach((el) => observer.observe(el));
}
*/


function makeUtilitiesFixed() {
  const utilitiesWrapper = document.querySelector(".toolbar__sort-filter");
  if (!utilitiesWrapper) return;

  const shopifySection = utilitiesWrapper.closest(".shopify-section");
  if (!shopifySection) return;

  const headerSection = document.querySelector(".header-section");
  const headerStickyTopWrapper = document.querySelector(".header-sticky-top-wrapper");

  const previousSiblings = [];
  let sibling = shopifySection.previousElementSibling;
  const hasNonZeroHeight = (el) => el && (el.offsetHeight > 0 || el.getBoundingClientRect().height > 0);

  while (sibling) {
    if (hasNonZeroHeight(sibling)) previousSiblings.push(sibling);
    sibling = sibling.previousElementSibling;
  }

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  function calculateTotalTopHeight() {
    let headerHeight = 0;

    if (window.innerWidth < 1200 && headerStickyTopWrapper) {
      headerHeight = headerStickyTopWrapper.getBoundingClientRect().height;
    } else if (headerSection) {
      headerHeight = headerSection.getBoundingClientRect().height;
    }

    const countdownBar = document.querySelector(".new-countdown-bar");
    if (countdownBar) {
      headerHeight += countdownBar.getBoundingClientRect().height;
    }
    
    const announcementBar = document.querySelector(".announcement-bar-section");
    if (announcementBar) {
      headerHeight += announcementBar.getBoundingClientRect().height;
    }
    
    return headerHeight;
  }

  if (!previousSiblings.length) {
    let isSticky = false;
    let initialOffset = null;

    const handleScroll = debounce(() => {
      if (initialOffset === null) initialOffset = shopifySection.offsetTop;
      const scrollY = window.scrollY || window.pageYOffset;
      const totalTopHeight = calculateTotalTopHeight();
      const triggerPoint = initialOffset + 200 - totalTopHeight;

      if (scrollY >= triggerPoint && !isSticky) {
        utilitiesWrapper.classList.add("sticky__nav");
        utilitiesWrapper.style.top = `${totalTopHeight}px`;
        isSticky = true;
      } else if (scrollY < triggerPoint && isSticky) {
        utilitiesWrapper.classList.remove("sticky__nav");
        utilitiesWrapper.style.top = "";
        isSticky = false;
      }
    }, 100);

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return;
  }

  let isSticky = false;
  let stickyTimeout;

  const handleIntersection = debounce((entries) => {
    const isAnySiblingVisible = entries.some((entry) => entry.isIntersecting);

    if (!isAnySiblingVisible && !isSticky) {
      const totalHeight = previousSiblings.reduce(
        (sum, el) => sum + el.getBoundingClientRect().height,
        0
      );

      clearTimeout(stickyTimeout);

      const totalTopHeight = calculateTotalTopHeight();

      if (totalHeight < 150) {
        stickyTimeout = setTimeout(() => {
          utilitiesWrapper.classList.add("sticky__nav");
          utilitiesWrapper.style.top = `${totalTopHeight}px`;
          isSticky = true;
        }, 700);
      } else {
        utilitiesWrapper.classList.add("sticky__nav");
        utilitiesWrapper.style.top = `${totalTopHeight}px`;
        isSticky = true;
      }
    } else if (isAnySiblingVisible && isSticky) {
      clearTimeout(stickyTimeout);
      utilitiesWrapper.classList.remove("sticky__nav");
      utilitiesWrapper.style.top = "";
      isSticky = false;
    }
  }, 100);

  const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    threshold: 0,
    rootMargin: "-10px",
  });

  previousSiblings.forEach((el) => observer.observe(el));
}

 window.subcategoryFilter = () => {
    // Select all elements with class .--top-filter-value
    document.querySelectorAll('.--top-filter-value').forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault(); // Prevent default action (e.g., navigation)
        console.log('element', element);
        // Access dataset from the target element
        const { id, value } = e.target.dataset;

        // Verify data-id exists
        if (!id) {
          console.error('data-id attribute missing on element:', element);
          return;
        }

        // Find the checkbox by ID
        const checkbox = document.getElementById(id);
        if (checkbox) {
          checkbox.click(); // Programmatically click the checkbox
          console.log(`Clicked checkbox with ID: ${id}, Value: ${value || 'N/A'}`);
        } else {
          console.error(`Checkbox with ID ${id} not found`);
        }
      });
    });
  };

document.addEventListener('DOMContentLoaded', function () {
  sortOpenerFunc();
  filterOpenFunc();
  window.layoutSwitcherFunc();
  window.hideActiveFilter();
  window.filterAccordion();
  window.clearFilter();
  window.subcategoryFilter();
  // scrollCollectionListsFunc();
  window.initWrapperHeightSync();
  window.loadMore();
  window.searchLoadMore();
  makeUtilitiesFixed();
  
  

  
  
});




